import React from "react";
import { useLocation, Link } from "react-router-dom";

export default function Breadcrumb({ menuData }) {
    const location = useLocation();

    const normalizePath = (path) => path.replace(/\/$/, '').toLowerCase();

    const findPath = (data, currentPath, path = []) => {
        if (!Array.isArray(data)) return [];

        const normalizedPath = normalizePath(currentPath);

        for (let item of data) {
            if (item && item.link && normalizePath(item.link) === normalizedPath) {
                return [...path, { name: item.label, link: item.link }];
            }

            if (item.children && Array.isArray(item.children)) {
                const found = findPath(item.children, currentPath, [...path, { name: item.label, link: item.link }]);
                if (found.length) return found;
            }
        }

        return [];
    };

    const currentPath = location.pathname;

    const breadcrumbItems = findPath(menuData, currentPath);

    if (breadcrumbItems.length === 0) {
        return null; 
    }

    return (
        <nav aria-label="breadcrumb" style={{ direction: "rtl" }}>
            <ol className="breadcrumb">
                {breadcrumbItems.map((item, index) => (
                    index === breadcrumbItems.length - 1 ? (
                        <li key={item.name} className="breadcrumb-item active" aria-current="page">
                            {item.name}
                        </li>
                    ) : (
                        <li key={item.name} className="breadcrumb-item">
                            <Link to={item.link}>{item.name}</Link>
                        </li>
                    )
                ))}
            </ol>
        </nav>
    );
}
